import _ from "lodash";

class InfoBlock {
    constructor(props) {
        /**
         * @property Repository
         * @type {Repository}
         */
        this.Repository = props.dependencies.Repository;
    }

    /**
     * @public
     * @method getActiveIngredients
     * @param params {{
     *     page: Number,
     *     itemsPerPage: Number
     * }}
     * @param success {Function}
     * @param error {Function}
     * @returns {InfoBlock}
     */
    getActiveIngredients(params, success, error) {
        if (_.isFunction(success) && _.isFunction(error)) {
            this.Repository.getActiveIngredients(params, success, error);
        }

        return this;
    }

    /**
     * @public
     * @method getArticleByActiveIngredient
     * @param activeIngredient {String}
     * @param success {Function}
     * @param error {Function}
     * @returns {InfoBlock}
     */
    getArticleByActiveIngredient(activeIngredient, success, error) {
        if (_.isString(activeIngredient) && _.isFunction(success) && _.isFunction(error)) {
            this.Repository.getArticleByActiveIngredient(activeIngredient, success, error);
        }

        return this;
    }
}

export default InfoBlock;
